'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import React__default from 'react';
import styled from 'styled-components';
import { IconNoResultJobs, IconNoResultManagementJobs, IconNoResultInterview, IconNoResultSalary, IconNoResult404, IconNoResultJobAlert, IconNoProfileViews, IconNoSearchable, IconNoAppliedJob } from './icons.js';

var StyledNoResult = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    text-align: center !important;\n    font-size: 14px;\n\n    > .icon-wrapper {\n        margin-bottom: 12px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    > .title {\n        font-size: 15px;\n        margin-bottom: 10px;\n        font-weight: 600;\n        line-height: 1.5;\n    }\n"], ["\n    text-align: center !important;\n    font-size: 14px;\n\n    > .icon-wrapper {\n        margin-bottom: 12px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    > .title {\n        font-size: 15px;\n        margin-bottom: 10px;\n        font-weight: 600;\n        line-height: 1.5;\n    }\n"])));
var STATIC_DATA = {
    searchResult: {
        icon: IconNoResultJobs,
        vi: {
            title: 'Hiện chưa có công việc nào theo tiêu chí bạn tìm',
            description: ''
        },
        en: {
            title: 'We have not found jobs for this search at the moment',
            description: ''
        }
    },
    topManagementJobs: {
        icon: IconNoResultManagementJobs,
        vi: {
            title: 'Hiện chưa có công việc nào theo tiêu chí bạn tìm',
            description: ''
        },
        en: {
            title: 'We have not found jobs for this search at the moment',
            description: ''
        }
    },
    interview: {
        icon: IconNoResultInterview,
        vi: {
            title: 'Hiện tại VietnamWorks chưa có bộ câu hỏi phỏng vấn cho vị trí này.',
            description: 'Bạn hãy quay lại sau nhé. VietnamWorks sẽ chuẩn bị sớm thôi.'
        },
        en: {
            title: 'Currently, VietnamWorks have no interview questions for this position.',
            description: 'Please come back later. VietnamWorks will prepare soon.'
        }
    },
    salary: {
        icon: IconNoResultSalary,
        vi: {
            title: 'Hiện tại VietnamWorks chưa có bộ câu hỏi phỏng vấn cho vị trí này.',
            description: 'Bạn hãy quay lại sau nhé. VietnamWorks sẽ chuẩn bị sớm thôi.'
        },
        en: {
            title: 'Currently, VietnamWorks have no interview questions for this position.',
            description: 'Please come back later. VietnamWorks will prepare soon.'
        }
    },
    error404: {
        icon: IconNoResult404,
        vi: {
            title: 'Xin lỗi. chúng tôi không thể tìm thấy trang bạn đã yêu cầu. Cùng nhau khám phá thêm nhiều việc làm chứ?',
            description: ''
        },
        en: {
            title: "Sorry, we couldn't find the page you requested. Let's discover more jobs, shall we?",
            description: ''
        }
    },
    jobAlert: {
        icon: IconNoResultJobAlert,
        vi: {
            title: 'Bạn chưa tạo Thông báo việc làm nào',
            description: ''
        },
        en: {
            title: 'You have not created any job alert yet',
            description: ''
        }
    },
    profileViews: {
        icon: IconNoProfileViews,
        vi: {
            title: 'Bạn chưa có lượt ghé thăm nào',
            description: ''
        },
        en: {
            title: 'You have not had any visits yet',
            description: ''
        }
    },
    searchable: {
        icon: IconNoSearchable,
        vi: {
            title: 'Nhà tuyển dụng không thể xem hồ sơ của bạn',
            description: ''
        },
        en: {
            title: 'Employers can not view your resume',
            description: ''
        }
    },
    appliedJob: {
        icon: IconNoAppliedJob,
        vi: {
            title: 'Bạn chưa ứng tuyển vị trí nào',
            description: ''
        },
        en: {
            title: 'You have not applied for any job yet',
            description: ''
        }
    },
    viewedJob: {
        icon: IconNoAppliedJob,
        vi: {
            title: 'Bạn chưa xem công việc nào',
            description: ''
        },
        en: {
            title: 'You have not viewed for any job yet',
            description: ''
        }
    },
    savedJob: {
        icon: IconNoAppliedJob,
        vi: {
            title: 'Bạn chưa lưu công việc nào',
            description: ''
        },
        en: {
            title: 'You have not saved for any job yet',
            description: ''
        }
    }
};
function NoResult(_a) {
    var _b, _c, _d, _e, _f;
    var pageName = _a.pageName, _g = _a.language, language = _g === void 0 ? 'vi' : _g, children = _a.children, title = _a.title, _h = _a.customIcon, customIcon = _h === void 0 ? null : _h;
    var titleText = !title ? ((_c = (_b = STATIC_DATA === null || STATIC_DATA === void 0 ? void 0 : STATIC_DATA[pageName]) === null || _b === void 0 ? void 0 : _b[language]) === null || _c === void 0 ? void 0 : _c.title) || '' : title;
    var description = ((_e = (_d = STATIC_DATA === null || STATIC_DATA === void 0 ? void 0 : STATIC_DATA[pageName]) === null || _d === void 0 ? void 0 : _d[language]) === null || _e === void 0 ? void 0 : _e.description) || '';
    var Icon = ((_f = STATIC_DATA === null || STATIC_DATA === void 0 ? void 0 : STATIC_DATA[pageName]) === null || _f === void 0 ? void 0 : _f.icon) || '';
    var CustomIcon = customIcon;
    return (React__default.createElement(StyledNoResult, null,
        React__default.createElement("div", { className: 'icon-wrapper' }, CustomIcon || React__default.createElement(Icon, null)),
        React__default.createElement("h2", { className: 'title' }, titleText),
        React__default.createElement("div", null, children || description)));
}
var templateObject_1;

export { NoResult as default };
//# sourceMappingURL=index.js.map
